import { styled } from '@linaria/react'
import React from 'react'
import swapIcon from '@assets/icon/swap-red-icon.svg'

function SwapButton({onClick}:any) {
  return (
    <Button onClick={(e)=>{if(typeof onClick === "function")onClick(e)}}><div><img src={swapIcon} alt='swap icon'/><p>Swap</p></div></Button>
  )
}

export default SwapButton

const Button = styled.button`
    max-width: 104px;
    background-color: transparent;
    cursor: pointer;
    max-height: 45px;
    padding: 12px 24px;
    display: flex;
    justify-content: center;
    font-size: 12px;
    font-weight: 600;
    align-items: center;
    color: #C50000;
    border: solid #C50000 1px;
    border-radius: 100px;
    div {
        display: flex;
        justify-content: center;
        cursor: pointer;
        height: 100%;
        align-items: center;
        gap: 8px;
        img {
            margin-top: -3px;
        }
    }
`
